import { render, staticRenderFns } from "./SchematicPart.vue?vue&type=template&id=50e8d04d&scoped=true&"
import script from "./SchematicPart.vue?vue&type=script&lang=ts&"
export * from "./SchematicPart.vue?vue&type=script&lang=ts&"
import style0 from "./SchematicPart.vue?vue&type=style&index=0&id=50e8d04d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e8d04d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VContainer,VSkeletonLoader})
